import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import BatchQRCode from '@/views/BatchQRCode.vue'
import BatchBarcode from '@/views/BatchBarcode.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/batch-qrcode',
    name: 'BatchQRCode',
    component: BatchQRCode,
    meta: {
      title: '批量生成二维码'
    }
  },
  {
    path: '/batch-barcode',
    name: 'BatchBarcode',
    component: BatchBarcode,
    meta: {
      title: '批量生成条形码'
    }
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title + ' - 鲁班工具集'
  }
  next()
})

export default router
